export default __webpack_public_path__ + "static/media/48.9971f6e1.gif";